import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const Role = {
    BackendUser: 'Administrador',
    ExecutiveUser: 'Ejecutivo',
    ClientUser: 'Cliente'
}

export default new Router({
    //mode: "history",
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        if (to.hash) {
            return {
                selector: to.hash
            }
        }
        return { x: 0, y: 0 }
    },
    base: process.env.BASE_URL,
    routes: [{
            path: "/",
            redirect: "/dashboard",
            component: () =>
                import ("@/view/layout/Layout"),
            children: [{
                    path: "/dashboard",
                    name: "dashboard",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/Home.vue"),
                },
                {
                    path: "/propiedades",
                    name: "propiedades",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/Propiedades.vue")
                },
                {
                    path: "/detalle/:idNegocio",
                    name: "detalle",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/Detalle.vue"),
                },
                {
                    path: "/estado-compra/:idNegocio",
                    name: "estado-compra",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/EstadoCompra.vue"),
                }, {
                    path: "/avance-obra/:idNegocio",
                    name: "avance-obra",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/AvanceObra.vue"),
                },
                {
                    path: "/documentos/:idNegocio",
                    name: "documentos",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/Documentos.vue"),
                },
                {
                    path: "/pagos/:idNegocio",
                    name: "pagos",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/Pagos.vue"),
                },
                {
                    path: "/documentos-propiedad/:idNegocio",
                    name: "documentos-propiedad",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/DocumentosPropiedad.vue"),
                },
                {
                    path: "/refiere",
                    name: "refiere",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/Refiere.vue"),
                },
                {
                    path: "/beneficios",
                    name: "beneficios",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/Beneficios.vue"),
                },
                {
                    path: "/novedades",
                    name: "novedades",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/Novedades.vue"),
                },
                {
                    path: "/novedad/:name",
                    name: "novedad",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/Novedad.vue"),
                },
                {
                    path: "/ayuda",
                    name: "ayuda",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/Ayuda.vue"),
                },
                {
                    path: "/solicitudes",
                    name: "solicitudes",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/Solicitudes.vue"),
                },
                {
                    path: "/notificaciones",
                    name: "notificaciones",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/Notificaciones.vue"),
                },
                {
                    path: "/cotiza",
                    name: "cotiza",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/Cotiza.vue"),
                },
                {
                    path: "/mis-datos",
                    name: "mis-datos",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/MisDatos.vue"),
                }, {
                    path: "/bases-legales",
                    name: "bases-legales",
                    meta: { authorize: [Role.ClientUser] },
                    component: () =>
                        import ("@/view/pages/private/BasesLegales.vue"),
                },
            ]
        },
        {
            //Contratacion
            path: "/private",
            component: () =>
                import ("@/view/layout/Layout"),
            children: [

            ]
        },
        {
            path: "/error",
            name: "error",
            component: () =>
                import ("@/view/pages/error/Error.vue"),
            children: [{
                    path: "error-1",
                    name: "error-1",
                    component: () =>
                        import ("@/view/pages/error/Error-1.vue")
                },
                {
                    path: "error-2",
                    name: "error-2",
                    component: () =>
                        import ("@/view/pages/error/Error-2.vue")
                },
                {
                    path: "error-3",
                    name: "error-3",
                    component: () =>
                        import ("@/view/pages/error/Error-3.vue")
                },
                {
                    path: "error-4",
                    name: "error-4",
                    component: () =>
                        import ("@/view/pages/error/Error-4.vue")
                },
                {
                    path: "error-5",
                    name: "error-5",
                    component: () =>
                        import ("@/view/pages/error/Error-5.vue")
                },
                {
                    path: "error-6",
                    name: "error-6",
                    component: () =>
                        import ("@/view/pages/error/Error-6.vue")
                }
            ]
        },

        {
            path: "/",
            component: () =>
                import ("@/view/pages/auth/Auth"),
            children: [{
                    name: "logintoken",
                    path: "/logintoken/:token",
                    component: () =>
                        import ("@/view/pages/auth/LoginExt"),
                },
                {
                    name: "login",
                    path: "/login",
                    component: () =>
                        import ("@/view/pages/auth/Login"),
                },
                {
                    name: "register",
                    path: "/register",
                    component: () =>
                        import ("@/view/pages/auth/Register"),
                },
                {
                    name: "changePassword",
                    path: "/changePassword/:token/view",
                    component: () =>
                        import ("@/view/pages/auth/ChangePassword"),
                },
                {
                    name: "register",
                    path: "/register",
                    component: () =>
                        import ("@/view/pages/auth/Register"),
                },
                {
                    name: "recovery",
                    path: "/recovery",
                    component: () =>
                        import ("@/view/pages/auth/Recovery"),
                },
                {
                    name: "confirm",
                    path: "/confirm/:token",
                    component: () =>
                        import ("@/view/pages/auth/RecoveryConfirm"),
                },
            ],
        },
        {
            path: "*",
            redirect: "/404"
        },
        {
            // the 404 route, when none of the above matches
            path: "/404",
            name: "404",
            component: () =>
                import ("@/view/pages/error/Error-1.vue")
        },



    ]
});